import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideshowComponent implements OnChanges {

  private _photos: any[] = [];
  public total: number = 0;
  public last: number = 0;
  public pos: number = 0;
  public fullscreen = false;
  public dim = '400';

  @Input()
  synap: string = null;

  @Input()
  values: any;

  @Input()
  set item(item: any) {
    this.values = item?.values;
    this.refreshPhotos();
  }
  get photos() {
    return this._photos;
  }


  constructor() { }

  ngOnChanges(_changes: SimpleChanges): void {
    this.refreshPhotos();
  }

  private refreshPhotos(): void {
    const synapData = this.synap && this.values?.synaps?.[this.synap];

    if (synapData) {
      this._photos = Object.keys(synapData)
        .map(key => synapData[key])
        .sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
    } else {
      this._photos = [];
    }

    this.total = this._photos.length;
    this.last = this.total > 0 ? this.total - 1 : 0;
    if (this.pos > this.last) {
      this.pos = 0;
    }
  }

  previous() {
    if (this.pos > 0) {
      this.pos--;
    } else {
      this.pos = this.last;
    }
  }

  next() {
    if (this.pos < this.last) {
      this.pos++;
    } else {
      this.pos = 0;
    }
  }

  toggleFullscreen() {
    this.fullscreen = !this.fullscreen;
    if (this.fullscreen) {
      this.dim = '1200'
    } else {
      this.dim = '400';
    }
  }
}
